import React from 'react';
import { Chip } from '@mui/material';
import MegaPhoneIcon from '../../images/icons/megaphone.svg?react';

const SponsoredChip = ({
  label = 'Sponsored',
  icon: Icon = MegaPhoneIcon,
  variant = 'filled',
  size = 'small',
  color = 'primary',
  style = {},
  chipStyle = {},
  ...props
}) => {
  return (
    <Chip
      label={
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', ...style }}>
          <Icon />
          <span>{label}</span>
        </div>
      }
      variant={variant}
      color={color}
      size={size}
      style={chipStyle}
      {...props}
    />
  );
};

export default SponsoredChip;
